export const Api = {
  catalogs: '/catalog',
  subCatalogs: '/catalog/all',
};
